import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import VueBus from "vue-bus";
import store from "./store";
import axios from "axios";
import VueQRCodeComponent from "vue-qrcode-component";
import VueI18n from "vue-i18n";
import { VueMaskDirective } from 'v-mask'
import truncate from 'lodash/truncate'
import { userNumber } from '@/utils/lib.js'
import CountryFlag from 'vue-country-flag'
import IdleVue from 'idle-vue'
 
const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60000 * 10, // 60 seconds, * 10 > 10 minutes
  startAtIdle: false
});

Vue.component('country-flag', CountryFlag)
Vue.component("qr-code", VueQRCodeComponent);

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.use(VueI18n);

Vue.directive('mask', VueMaskDirective);

Vue.filter("truncate", function (value) {
  if (!value) return "";
  return truncate(value, {
    length: 13,
    omission: "...",
  });
});

Vue.filter("truncateLong", function (value) {
  if (!value) return "";
  return truncate(value, {
    length: 60,
    omission: "...",
  });
});

Vue.filter("formatedPhone", function (value) {
  if (!value) return "";
  return userNumber(value)
});

Vue.filter("formatWithComma", function (value) {
  if (!value) return "";
  return String(value).replace(/(.)(?=(\d{3})+$)/g, "$1,");
});

const messages = {
  en: {
    $vuetify: {
      commonTexts: {
        activate: 'Activate',
        activateUnlockPrivate: 'Unlock private caller ID',
        buttons: {
          save: "Save",
          cancel: "Cancel",
          confirm: "Confirm",
          removeService: "Remove service",
          remove: "Remove",
          delete: 'Delete'
        },
        options: {
          sendToMail: "Send to email",
          servicePrice: "Service price",
          allNumbers: "All numbers",
          selectNumbers: "Select numbers",
          agreeToTerms: "Agree to terms",
        },
        goToAccount: 'Go to account',
        createNew: 'Create new',
        loading: 'Loading',
        printImport: 'Print/Import',
        selectFromList: 'Select'
      },
      accounts: {
        pageTexts: {
          mainTitle: "Personal cabinet of",
          login: {
            loginLabel: "Login",
            sendSms: "Send SMS",
            call: "Call",
            resend: "Resend OTP",
          },
          userSelect: "Select User",
          options: {
            account: "Account",
            abroad: "Abroad",
          },
        },
      },
      account: {
        accountArea: 'Account',
        accountOptionButtons: {
          users: "Users",
          payments: "Payments",
          profile: "My details",
        },
        newUserWizard: {
          newUserLabel: 'Create new user',
          wizardSteps: {
            step1: 'New user form',
            step2: 'Would you like to add device?',
            step3: 'New device form',
            step4: 'Would you like to add number?',
            step5: 'New number form',
            step6: 'Would you like to adjust call settings?'
          },
          continueLater: 'Save and continue later',
          optional: 'Optional',
          skip: 'Skip',
          continue: 'Continue',
          stepBack: 'Back'
        }
      },
      user: {
        userArea: 'personal cabinet',
        userOptionButtons: {
          profile: "My Details",
          subscriptions: "Packages",
          devices: "Devices",
          numbers: "Numbers",
          calls: "Calls",
          changeSim: "Change SIM",
        },
        userProfileFields: {
          fullName: "Full name",
          address: "Address",
          email: "Email",
          phoneNumber: "Phone number",
          identification: "ID",
        },
        userProfileLabel: 'User details',
        userCalls: {
          voicemail: "Voicemail",
          speedDial: "Speed dial",
          callerId: "Caller ID",
          unlockPrivate: "Unlock private number",
          callRecord: "Call record",
          reports: "Reports",
        },
        userReports: {
          cardLabel: 'User call reports',
          sortByEndpoint: 'Sort by device',
          noLinkedDevices: 'No devices for this user',
          noReportsForEndpoint: 'No reports for selected device'
        },
        // userPackages: {

        // }
      },
      forms: {
        newUserFormTitle: 'Craete new user',
        newEndpointFormTitle: 'Create new device',
        newDIDFormTitle: 'Create new number'
      }
    },
  },
  ru: {
    $vuetify: {
      commonTexts: {
        activate: 'Активировать',
        activateUnlockPrivate: 'Включить идентификатор вызывающего абонента',
        buttons: {
          save: "Сохранить",
          cancel: "Отмена",
          confirm: "Подтвердить",
          removeService: "Удалить сервис",
          remove: "Удалить", 
          delete: 'Удалить'
        },
        options: {
          sendToMail: "Отправить по электронной почте",
          servicePrice: "Цена услуги",
          allNumbers: "Все номера",
          selectNumbers: "Выберите номера",
          agreeToTerms: "Согласен с условиями",
        },
        goToAccount: 'Перейти к аккаунту',
        createNew: 'Создать новый',
        loading: 'загрузка',
        printImport: 'Печать/импорт',
        selectFromList: 'Выберите'
      },
      accounts: {
        pageTexts: {
          mainTitle: "Личный кабинет",
          login: {
            loginLabel: "Войти",
            sendSms: "Отправить СМС",
            call: "Звонок по телефону ",
            resend: "Повторить отправку",
          },
          userSelect: "Выбрать пользователя",
          options: {
            account: "Профиль",
            abroad: "За границей",
          },
        },
      },
      account: {
        accountArea: 'Аккаунт',
        accountOptionButtons: {
          users: "Пользователи",
          payments: "Платежи",
          profile: "Мои данные",
        },
        newUserWizard: {
          newUserLabel: 'Создать нового пользователя',
          wizardSteps: {
            step1: 'Форма нового пользователя',
            step2: 'Хотите добавить устройство?',
            step3: 'Форма нового устройства',
            step4: 'Хотите добавить номер?',
            step5: 'Новая форма номерa',
            step6: 'Хотите изменить настройки вызова?'
          },
          continueLater: 'Сохранить и продолжить позже',
          optional: 'Необязательно',
          skip: 'Пропустить',
          continue: 'Продолжить',
          stepBack: 'Назад'
        }
      },
      user: {
        userArea: 'личный кабинет',
        userOptionButtons: {
          profile: "Мои данные",
          subscriptions: "Пакеты",
          devices: "Устройства",
          numbers: "Номера телефона",
          calls: "Разговоры",
          changeSim: "Сменить SIM",
        },
        userProfileFields: {
          fullName: "Полное имя",
          address: "Адрес",
          email: "Электронная почта",
          phoneNumber: "Номер телефона",
          identification: "Идентификация",
        },
        userProfileLabel: 'Данные пользователя',
        userCalls: {
          voicemail: "Голосовая почта",
          speedDial: "Быстрый набор",
          callerId: "Идентификатор вызывающего абонента",
          unlockPrivate: "Разблокировать закрытый номер",
          callRecord: "Запись звонков",
          reports: "Отчеты",
        },
        userReports: {
          cardLabel: 'Отчеты звонков пользователя',
          sortByEndpoint: 'Фильтр по устройству',
          noLinkedDevices: 'Нет устройств для этого пользователя',
          noReportsForEndpoint: 'Нет отчетов для выбранного устройства'
        }
      },
      forms: {
        newUserFormTitle: 'Создать нового пользователя',
        newEndpointFormTitle: 'Создать новое устройство',
        newDIDFormTitle: 'Создать новый номер'
      }
    },
  },

  he: {
    $vuetify: {
      commonTexts: {
        activate: 'הפעל',
        activateUnlockPrivate: 'הפעל זיהוי מתקשר',
        buttons: {
          save: "שמור",
          cancel: "בטל",
          confirm: "אישור",
          removeService: "הסר שירות",
          remove: "הסר",
          delete: 'מחק'
        },
        options: {
          sendToMail: "שלח למייל",
          servicePrice: "עלות השירות",
          allNumbers: "כל המספרים",
          selectNumbers: "בחר מספרים",
          agreeToTerms: "אני מסכים ל",
        },
        goToAccount: 'עבור לחשבון של',
        createNew: 'צור חדש',
        loading: 'טוען',
        printImport: 'הדפס/יצוא',
        selectFromList: 'בחר'
      },
      accounts: {
        pageTexts: {
          mainTitle: "האזור האישי של",
          login: {
            loginLabel: "התחבר",
            sendSms: "SMS שלח",
            call: "שיחה",
            resend: "שלח שוב",
          },
          userSelect: "בחירת משתמש",
          options: {
            account: "החשבון שלי",
            abroad: "חו״ל",
          },
        },
      },
      account: {
        accountArea: 'היי',// 'החשבון של ',
        accountOptionButtons: {
          users: "מנויים",
          payments: "תשלומים",
          profile: "הפרטים שלי",
          addNewSim: "הפעלת סים חדש"
        },
        newUserWizard: {
          newUserLabel: 'יצירת משתמש חדש',
          wizardSteps: {
            step1: 'טופס משתמש חדש',
            step2: 'האם ברצונך להוסיף מכשיר?',
            step3: 'טופס מכשיר חדש',
            step4: 'רוצה להוסיף מספר?',
            step5: 'טופס מספר חדש',
            step6: 'האם תרצה לשנות את הגדרות השיחה?'
          },
          continueLater: 'שמור והמשך מאוחר יותר',
          optional: 'אופציונלי',
          skip: 'דלג',
          continue: 'המשך',
          stepBack: 'חזור'
        }
      },
      user: {
        userArea: 'ניהול מנוי',
        userOptionButtons: {
          profile: "הפרטים שלי",
          subscriptions: 'חבילות', //"שירותים נוספים",
          devices: 'ציוד קצה',//"מכשירים",
          numbers: "מספרים",
          calls: "שיחות",
          changeSim: "החלף סים",
        },
       
        userProfileFields: {
          fullName: "שם מלא",
          address: "כתובת",
          email: "אימייל",
          phoneNumber: "מספר טלפון",
          identification: "זיהוי",
        },
        userProfileLabel: 'פרטי המשתמש',
        userCalls: {
          voicemail: "תא קולי",
          speedDial: "חיוג מהיר",
          callerId: "מספר מוצג",
          unlockPrivate: "זיהוי חסום",
          callRecord: "הקלטת שיחות",
          reports: "פרוט שיחות",
        },
        userReports: {
          cardLabel: 'פירוט שיחות',
          sortByEndpoint: 'סנן לפי מכשיר',
          noLinkedDevices: 'אין מכשירים למשתמש זה',
          noReportsForEndpoint: 'אין דוחות למכשיר שנבחר'
        }
      },
      forms: {
        newUserFormTitle: 'צור משתמש חדש',
        newEndpointFormTitle: 'צור מכשיר חדש',
        newDIDFormTitle: 'צור מספר חדש'
      }
    },
  },
};

const i18n = new VueI18n({
  locale: "he",
  // lazy:true,
  fallbackLocale: "ru",
  messages: messages,
  t: (key, ...params) => {
    i18n.t(key, params);
  },
});


Vue.prototype.$axios.interceptors.response.use(undefined, function(error) {
  // console.log('interceptor', error);
  if (error) {
    const originalRequest = error.config;
    // console.log("interceptors : ", originalRequest);
    if (error.response.status === 401 && !originalRequest._retry) {
      console.log("need to logout error 401 ");
      originalRequest._retry = true;
      // store.dispatch("AUTH_LOGOUT");
      return router.push("/");
    }
  }
});

Vue.prototype.$axios.interceptors.response.use(function (response) {
  // console.log('interceptors for session ', response);
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response;
  }, function (error) {
    // console.log('interceptors for error ', error);
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  if(error.response.status === 403) {
      // redirect to login page
      window.location.href = "/";
  }
  if (error.response.status === 401) {
    console.log("need to logout error 401 ");
    // originalRequest._retry = true;
    // store.dispatch("AUTH_LOGOUT");
    return router.push("/");
  }
  return Promise.reject(error);
});

Vue.use(VueBus);

new Vue({
  router,
  i18n,
  vuetify,
  store,
  render: (h) => h(App),
}).$mount("#app");
